import React, { Component } from "react";
import TopOptions from "../../components/TopOptions";
import styled from "styled-components";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import ReportDAO from "../../DAO/ReportDAO";
import { connect } from "react-redux";
import moment from "moment";
import SearchSelect from "../../helpers/SearchSelect";
import CommonFunctions from "../../helpers/CommonFunctions";
import UserDAO from "../../DAO/UserDAO";
import { DatePicker } from "../../components/CustomDatePicker";
import { notify } from "../../helpers/FlashMessage";

let options = {
    chart: {
        type: "pie",
    },
    title: {
        text: "",
    },
    colors: ["#28b9ac", "#1ab2d5", "#eda224", "#700242"],
};

class VisitorByChannel extends Component {
    constructor(props) {
        super(props);
        let lastMonth = new Date();
        lastMonth.setMonth(lastMonth.getMonth() - 1);
        this.state = {
            filter_fields: {
                started_date: lastMonth,
                end_date: new Date(),
                visitor: { value: 0, label: "Tout" },
            },
            statistical_fields: {
                show_statistical: false,
                other: 0,
                field: 0,
                email: 0,
                phone: 0,
            },
            data: {
                visitors: [],
            },
            preload: {
                users: [],
            },
            accounts: [],
        };
    }
    async componentDidMount() {
        document.title = "Comptes - Sobrus Labs";
        this.getVisitsByCannel();
        // this.getConnectedUserInfos();
    }

    render() {
        const { filter_fields, statistical_fields, data, preload } = this.state;

        // after loading data and calc statistical
        options.series = [
            {
                data: [
                    ["Autre", statistical_fields.other],
                    ["Terrain", statistical_fields.field],
                    ["Téléphone", statistical_fields.phone],
                    ["E-mail", statistical_fields.email],
                ],
            },
        ];

        return (
            <Main_container className="Main_container">
                <TopOptions title="Événements par visiteur/canal"></TopOptions>
                <Bloc className="Bloc">
                    <div className="bloc_header">
                        <h2>Options des rapports</h2>
                        <div className="bloc_header_btns"></div>
                    </div>
                    <Form_container>
                        <Row>
                            <FullRow>
                                <SearchSelect
                                    name="report"
                                    fetchedUrl="/api/utilisateurs"
                                    HTTPMethod="post"
                                    receivedObject="utilisateurs"
                                    optionLabelProperty="fullname"
                                    optionValueProperty="id"
                                    value={filter_fields.visitor}
                                    placeholder="Sélectionner un visiteur"
                                    onChange={(e) => {
                                        if (e && e.value.length !== 0) {
                                            this.onSearchChange(e);
                                        }
                                    }}
                                />
                            </FullRow>
                        </Row>
                        <Row>
                            <Left_Input_container>
                                <DatePicker
                                    selected={filter_fields.started_date}
                                    onChange={(date) => {
                                        this.setFieldValue("started_date", date, this.getVisitsByCannel.bind(this));
                                    }}
                                    dateFormat="yyyy-MM-dd"
                                    showTimeSelect={false}
                                    label="Date de début*"
                                    id="start_date_id"
                                />
                            </Left_Input_container>
                            <Right_input_container>
                                <DatePicker
                                    selected={filter_fields.end_date}
                                    onChange={(date) => {
                                        this.setFieldValue("end_date", date, this.getVisitsByCannel.bind(this));
                                    }}
                                    dateFormat="yyyy-MM-dd"
                                    showTimeSelect={false}
                                    label="Date de fin*"
                                    id="end_date_id"
                                />
                            </Right_input_container>
                        </Row>
                    </Form_container>
                </Bloc>
                <Bloc2 className="Bloc">
                    <div className="bloc_header">
                        <h2>Événements par canal</h2>
                        <div className="bloc_header_btns"></div>
                    </div>
                    <div className="bloc_content table_wrraper">{statistical_fields.show_statistical && <HighchartsReact updateArgs={[true, true, true]} highcharts={Highcharts} options={options} />}</div>
                </Bloc2>
                <Bloc className="Bloc">
                    <div className="bloc_header">
                        <h2>Événements par visiteur/canal</h2>
                        <div className="bloc_header_btns"></div>
                    </div>
                    <div className="bloc_content table_wrraper">
                        <table className="table processableTable" id="26555_e2d99ecca39dab4b0c717798144e1d8f" data-ajax_url="/invoices" data-object_table="invoices">
                            <thead>
                                <tr className="table_th_orderable">
                                    <Th></Th>
                                    <Th>Téléphone</Th>
                                    <Th>E-mail</Th>
                                    <Th>Terrain</Th>
                                    <Th>Autre</Th>
                                    <Th>Total</Th>
                                    <Th>Total (%)</Th>
                                </tr>
                            </thead>

                            <tbody>
                                {data.visitors.length !== 0 &&
                                    data.visitors.map((object, index) => {
                                        const row_total = this.getRowTotal(object["Téléphone"], object["E-mail"], object["Terrain"], object[""]);
                                        return (
                                            <Tr key={"key_" + index}>
                                                <Td>{object["fullname"]}</Td>
                                                <Td>{object["Téléphone"]}</Td>
                                                <Td>{object["E-mail"]}</Td>
                                                <Td>{object["Terrain"]}</Td>
                                                <Td>{object[""]}</Td>
                                                <Td>{row_total}</Td>
                                                <Td>{`${this.getRowTotalPercent(row_total, statistical_fields.field + statistical_fields.other + statistical_fields.email + statistical_fields.phone)}%`}</Td>
                                            </Tr>
                                        );
                                    })}

                                <Tr>
                                    <Td>{"Total"}</Td>
                                    <Td>{statistical_fields.phone}</Td>
                                    <Td>{statistical_fields.email}</Td>
                                    <Td>{statistical_fields.field}</Td>
                                    <Td>{statistical_fields.other}</Td>
                                    <Td>{statistical_fields.field + statistical_fields.other + statistical_fields.email + statistical_fields.phone}</Td>
                                    <Td>{statistical_fields.field + statistical_fields.other + statistical_fields.email + statistical_fields.phone === 0 ? `0%` : `100%`}</Td>
                                </Tr>
                            </tbody>
                        </table>
                    </div>
                </Bloc>
            </Main_container>
        );
    }

    getRowTotal = (num_1, num_2, num_3, num_4) => {
        let tmp_num_1 = 0;
        let tmp_num_2 = 0;
        let tmp_num_3 = 0;
        let tmp_num_4 = 0;
        if (num_1) {
            tmp_num_1 = parseInt(num_1);
        }
        if (num_2) {
            tmp_num_2 = parseInt(num_2);
        }
        if (num_3) {
            tmp_num_3 = parseInt(num_3);
        }
        if (num_4) {
            tmp_num_4 = parseInt(num_4);
        }
        return tmp_num_1 + tmp_num_2 + tmp_num_3 + tmp_num_4;
    };

    getRowTotalPercent = (value, base) => {
        return base ? Number((value / base) * 100).toFixed(3) : 0;
    };

    formattedDate = (date) => {
        return moment(date).format("YYYY-MM-DD");
    };

    setFieldValue = (fieldName, fieldValue, callBack = () => { }) => {
        this.setState(
            (prevState) => ({
                ...prevState,
                filter_fields: {
                    ...prevState.filter_fields,
                    [fieldName]: fieldValue,
                },
            }),
            () => {
                if (this.state.filter_fields[fieldName] !== null) callBack();
            }
        );
    };

    onSearchChange = (selectedOption) => {
        if (selectedOption) {
            this.setState(
                (prevState) => ({
                    ...prevState,
                    filter_fields: {
                        ...prevState.filter_fields,
                        visitor: selectedOption,
                    },
                }),
                this.getVisitsByCannel.bind(this)
            );
        }
    };
    async getConnectedUserInfos() {
        try {
            const params = {};
            const response = await UserDAO.getConnectedUserInfos(params);
            this.onSearchChange({ value: response.data.id, label: response.data.fullname });
        } catch (error) {
            notify({ msg: error.message, type: "danger" });
        }
    }

    getVisitsByCannel = async () => {
        try {
            const { filter_fields } = this.state;
            if (filter_fields.started_date && filter_fields.end_date) {
                const response = await ReportDAO.getVisitsByCannel(this.formattedDate(filter_fields.started_date), this.formattedDate(filter_fields.end_date), filter_fields.visitor.value === 0 ? "" : filter_fields.visitor.value);
                this.setState(
                    (prevState) => ({
                        ...prevState,
                        data: {
                            ...prevState.data,
                            visitors: response.data,
                        },
                    }),
                    () => {
                        let other = 0;
                        let field = 0;
                        let email = 0;
                        let phone = 0;

                        this.state.data.visitors.map((object) => {
                            if (object[""]) other = other + parseInt(object[""]);
                            if (object["Terrain"]) field = field + parseInt(object["Terrain"]);
                            if (object["E-mail"]) email = email + parseInt(object["E-mail"]);
                            if (object["Téléphone"]) phone = phone + parseInt(object["Téléphone"]);
                        });
                        if (other !== 0 || field !== 0 || email !== 0 || phone !== 0) {
                            this.setState(
                                (prevState) => ({
                                    ...prevState,
                                    statistical_fields: {
                                        ...prevState.statistical_fields,
                                        other: other,
                                        field: field,
                                        email: email,
                                        phone: phone,
                                        show_statistical: true,
                                    },
                                }),
                                () => this.state.statistical_fields
                            );
                        } else {
                            this.setState(
                                (prevState) => ({
                                    ...prevState,
                                    statistical_fields: {
                                        ...prevState.statistical_fields,
                                        other: other,
                                        field: field,
                                        email: email,
                                        phone: phone,
                                        show_statistical: false,
                                    },
                                }),
                                () => this.state.statistical_fields
                            );
                        }
                    }
                );
            }
        } catch (error) {
            notify({ msg: error.message, type: "danger" });
        }
    };
}

const FullRow = styled.div`
    width: 99%;
    height: 41px;
    display: inline-block;
    vertical-align: top;
`;
const Form_container = styled.div`
    margin-top: 38px;
`;
const Row = styled.div`
    width: 94%;
    margin: auto;
    margin-top: 18px;
`;
const Left_Input_container = styled.div`
    width: 48%;
    height: 41px;
    display: inline-block;
    vertical-align: top;
`;
const Right_input_container = styled.div`
    width: 48%;
    height: 41px;
    display: inline-block;
    vertical-align: top;
    margin-left: 51px;
`;

const Main_container = styled.div`
    height: 100%;
`;
const Bloc = styled.div`
    box-shadow: 0 1px 3px 0 #bcbcbc;
    width: 96.3%;
    position: relative;
    margin: auto;
    padding-bottom: 38px;
    margin-top: 10px;
    background: #fff;
`;
const Bloc2 = styled.div`
    box-shadow: 0 1px 3px 0 #bcbcbc;
    width: 96.3%;
    position: relative;
    margin: auto;
    margin-top: 10px;
    background: #fff;
`;
const Th = styled.th`
    padding-right: 10px;
`;
const Td = styled.td`
    border-top: 1px solid #8d8d8d;
    wordwrap: "break-word";
    font-weight: 400;
    padding: 6px 5px;
`;
const Tr = styled.tr`
    cursor: pointer;
`;

const mapStateToProps = (state) => {
    return {
        selected: state.selcted,
    };
};

export default connect(mapStateToProps)(VisitorByChannel);
